export const checkIfUserInfoCompleted = (userDocument) => {
    return (userDocument && userDocument.firstName && userDocument.email && userDocument.birthDate)
};